const baseUrlLogos = 'https://d23hwblhugcea5.cloudfront.net/Global/Studio-ui/';

export const comingSoonWallets = [
  {
    name: 'Polygon',
    src: `${baseUrlLogos}Polygon.png`,
  },
  {
    name: 'Ethereum',
    src: `${baseUrlLogos}Ethereum.png`,
  },
  {
    name: 'Avalanche',
    src: `${baseUrlLogos}Avalanche.png`,
  },
  {
    name: 'BNB',
    src: `${baseUrlLogos}BNB.png`,
  },
  {
    name: 'Klaytn',
    src: `${baseUrlLogos}Klaityn.png`,
  },

  {
    name: 'Aptos',
    src: `${baseUrlLogos}aptos.png`,
  },
  {
    name: 'Hedera',
    src: `${baseUrlLogos}hedera.png`,
  },
  {
    name: 'Optimism',
    src: `${baseUrlLogos}optimism.png`,
  },
  {
    name: 'Arbitrum',
    src: `${baseUrlLogos}Arbitrum.png`,
  },
  {
    name: 'Cosmos',
    src: `${baseUrlLogos}cosmos.png`,
  },
];
